module.exports = "button.btn.btn-primary{\r\n    color: white !important;\r\n}"